import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { PinboardCard } from '../../../PinboardCard/PinboardCard';
import styles from '../../../TimetableGrid/CardPicker/CardPicker.module.scss';
import { useTimetableStore } from '../../../TimetableGrid/TimetableProvider';
import { CardType } from '../../../TimetableVersion/graphql/types';

export const TimetableVersionLessonsTableCardCell = observer(({ uuid }: { uuid: string }) => {
  const store = useTimetableStore();

  const lessonCards = store.getCardsByLessonUuid(uuid);
  // stack by duration
  const stack: CardType[][] = [];
  lessonCards?.forEach((card) => {
    const duration = card.duration || 1;
    if (duration && stack[duration]) {
      stack[duration].push(card);
    } else {
      stack[duration] = [card];
    }
  });

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 'var(--spacing-2)',
          margin: 'var(--spacing-2) 0',
        }}
      >
        {stack?.map((cards) => {
          const c = cards[0];
          const count = cards.length;
          const cardClasses = classNames({
            [styles.multi]: cards.length >= 2,
          });
          return <PinboardCard className={cardClasses} card={c} count={count} key={c.uuid} passive={true} />;
        })}
      </div>
    </>
  );
});
